// Generated: screenshot sizes, so the tutorial page keeps its layout while
// images load. Rerun the size script after recapturing screenshots.

import i_acct_adjustments from "./acct-adjustments.png";
import i_acct_analytics from "./acct-analytics.png";
import i_acct_billing_list from "./acct-billing-list.png";
import i_acct_client_lunch from "./acct-client-lunch.png";
import i_acct_invoice_lines from "./acct-invoice-lines.png";
import i_acct_invoice from "./acct-invoice.png";
import i_acct_nav from "./acct-nav.png";
import i_acct_pay_card from "./acct-pay-card.png";
import i_acct_payroll_list from "./acct-payroll-list.png";
import i_acct_payroll_report from "./acct-payroll-report.png";
import i_acct_position_modal from "./acct-position-modal.png";
import i_acct_position_rates from "./acct-position-rates.png";
import i_acct_report_actions from "./acct-report-actions.png";
import i_acct_report_downloads from "./acct-report-downloads.png";
import i_acct_report_employees from "./acct-report-employees.png";
import i_acct_report_header from "./acct-report-header.png";
import i_acct_report_hours from "./acct-report-hours.png";
import i_acct_report_totals from "./acct-report-totals.png";
import i_acct_user_payroll from "./acct-user-payroll.png";
import i_batch_add_time from "./batch-add-time.png";
import i_batch_client_employee from "./batch-client-employee.png";
import i_batch_submit from "./batch-submit.png";
import i_import_edit_line from "./import-edit-line.png";
import i_import_rows from "./import-rows.png";
import i_import_save from "./import-save.png";
import i_import_upload from "./import-upload.png";
import i_login_link from "./login-link.png";
import i_login_password from "./login-password.png";
import i_login_reset from "./login-reset.png";
import i_login_use_password_button from "./login-use-password-button.png";
import i_rates_select from "./rates-select.png";
import i_rates_update from "./rates-update.png";
import i_settings_password from "./settings-password.png";
import i_station_clock_in from "./station-clock-in.png";
import i_station_clock_out from "./station-clock-out.png";
import i_station_login from "./station-login.png";
import i_station_setup from "./station-setup.png";
import i_time_add_button from "./time-add-button.png";
import i_time_add_client_employee from "./time-add-client-employee.png";
import i_time_add_rates from "./time-add-rates.png";
import i_time_add_submit from "./time-add-submit.png";
import i_time_add_times from "./time-add-times.png";
import i_time_batch_button from "./time-batch-button.png";
import i_time_entries_tab from "./time-entries-tab.png";
import i_time_import_button from "./time-import-button.png";
import i_time_rate_editor_button from "./time-rate-editor-button.png";
import i_time_station_button from "./time-station-button.png";
import i_users_add_button from "./users-add-button.png";
import i_users_create from "./users-create.png";
import i_users_details_edit from "./users-details-edit.png";
import i_users_edit_form from "./users-edit-form.png";
import i_users_export from "./users-export.png";
import i_users_filters from "./users-filters.png";
import i_users_invite from "./users-invite.png";
import i_users_open from "./users-open.png";
import i_users_tab from "./users-tab.png";

export const SIZES = {
  [i_acct_adjustments]: [1280, 860],
  [i_acct_analytics]: [1303, 260],
  [i_acct_billing_list]: [1280, 260],
  [i_acct_client_lunch]: [340, 164],
  [i_acct_invoice_lines]: [935, 191],
  [i_acct_invoice]: [935, 297],
  [i_acct_nav]: [533, 173],
  [i_acct_pay_card]: [1280, 200],
  [i_acct_payroll_list]: [1280, 371],
  [i_acct_payroll_report]: [1280, 479],
  [i_acct_position_modal]: [764, 318],
  [i_acct_position_rates]: [868, 260],
  [i_acct_report_actions]: [1238, 233],
  [i_acct_report_downloads]: [534, 62],
  [i_acct_report_employees]: [1280, 172],
  [i_acct_report_header]: [555, 314],
  [i_acct_report_hours]: [1276, 442],
  [i_acct_report_totals]: [1280, 323],
  [i_acct_user_payroll]: [1280, 860],
  [i_batch_add_time]: [810, 792],
  [i_batch_client_employee]: [547, 353],
  [i_batch_submit]: [1280, 792],
  [i_import_edit_line]: [560, 342],
  [i_import_rows]: [1280, 260],
  [i_import_save]: [530, 95],
  [i_import_upload]: [1280, 140],
  [i_login_link]: [496, 404],
  [i_login_password]: [496, 504],
  [i_login_reset]: [496, 504],
  [i_login_use_password_button]: [496, 404],
  [i_rates_select]: [560, 566],
  [i_rates_update]: [1280, 860],
  [i_settings_password]: [1052, 432],
  [i_station_clock_in]: [560, 260],
  [i_station_clock_out]: [561, 460],
  [i_station_login]: [828, 312],
  [i_station_setup]: [1290, 312],
  [i_time_add_button]: [667, 120],
  [i_time_add_client_employee]: [630, 348],
  [i_time_add_rates]: [630, 465],
  [i_time_add_submit]: [630, 465],
  [i_time_add_times]: [630, 348],
  [i_time_batch_button]: [667, 120],
  [i_time_entries_tab]: [1258, 175],
  [i_time_import_button]: [667, 120],
  [i_time_rate_editor_button]: [667, 120],
  [i_time_station_button]: [667, 120],
  [i_users_add_button]: [421, 120],
  [i_users_create]: [1280, 860],
  [i_users_details_edit]: [1280, 860],
  [i_users_edit_form]: [1280, 860],
  [i_users_export]: [421, 120],
  [i_users_filters]: [1225, 260],
  [i_users_invite]: [792, 389],
  [i_users_open]: [1270, 511],
  [i_users_tab]: [1248, 175],
};
